import { getAllClasses, getClassFilters, getClassSort } from "../../api"
import { ClassCard } from "../cards/ClassCard"
import ListData from "../common/ListData"

export const PreviousClasses = () => {
  return (
    <>
      <ListData
        getFilters={getClassFilters}
        getSort={getClassSort}
        getAllData={getAllClasses}
        initialFilters={{
          filter: {
            fromDate: null,
            toDate: new Date(),
          },
        }}
        Card={ClassCard}
        emptyText="No previous classes"
      />
      <ClassCard />
    </>
  )
}
